
export class Verification {
  session_url!: string;
  verification_result!: string;
  reason!: string;
  issued_date!: string;
  expiry_date!: string;
  id_document_number!: string;
  id_document_country!: string;
  id_document_type!: string;

  constructor(data: any = {}) {
    this.build(data);
  }

  private build(data: any = {}) {
    this.session_url = data.session_url;
    this.verification_result = data.verification_result;
    this.reason = data.reason;
    this.issued_date = data.issued_date;
    this.expiry_date = data.expiry_date;
    this.id_document_number = data.id_document_number;
    this.id_document_country = data.id_document_country;
    this.id_document_type = data.id_document_type;
  }
}
